<template>
	<div class="contacts">
		<fluke-card>
			<header>
				<div class="title">
					Contatos
				</div>
				<div class="description">
					Lista de todos os contatos
				</div>
			</header>
			<main>

				<v-select
					v-model="selected_filters"
					:items="filters"
					:menu-props="{ maxHeight: '400' }"
					@change="filter"
					label="Filtros"
					multiple
					hint="Selecione os tipos desejados"
					persistent-hint>
				</v-select>

				<v-data-table
					:headers="headers"
					:items="contacts"
					:search="search"
					:rows-per-page-items="[15,30,60]"
					rows-per-page-text="Linhas pos página"
					class="inner-tables">

					<template v-slot:items="props">
						<td>{{ props.item.name }}</td>
						<td>{{ props.item.type }}</td>
						<td>{{ props.item.email }}</td>
						<td>{{ props.item.showurl }}</td>
						<td>{{ props.item.createdAt }}</td>
					</template>
					<template v-slot:no-results>
						<v-alert
							:value="true"
							color="error"
							icon="warning">
							Sua busca por "{{ search }}" não achou nenhum resultado.
						</v-alert>
					</template>
				</v-data-table>
				<div class="flexsplit">
					<div class="searchtable">
						<v-text-field
							v-model="search"
							append-icon="search"
							label="Pesquise"
							single-line
							hide-details>
						</v-text-field>
					</div>
					<div></div>
				</div>
			</main>
			<footer>
				<download-excel
					class   = "fluke-btn export-btn"
					:data   = "contacts"
					:fields = "json_fields"
					worksheet = "Contact Worksheet"
					name    = "contato.xls">

					<i class="material-icons">get_app</i>
					Download XLS

				</download-excel>
			</footer>
		</fluke-card>
	</div>
</template>

<script>
import axios from 'axios';
import Card from '../../components/Main/Content/Card/Card.vue';
import Button from '../../components/Main/Content/Button/Button.vue';


export default {
	components: {
		'fluke-card': Card,
		'fluke-button': Button
	},
	data: function() {
		return {
			contacts: [],
			filters: [],
			selected_filters: [],
			search: '',
			headers: [
				{
					text: "Nome",
					align: 'left',
					value: 'name'
				},
				{
					text: "Tipo",
					align: 'left',
					value: 'type'
				},
				{
					text: "Email",
					align: 'left',
					value: 'email'
				},
				{
					text: "Origem",
					align: 'left',
					value: 'showurl'
				},
				{
					text: "Data",
					align: 'left',
					value: 'orignalCreatedAt'
				}
			],
			json_fields: {
				'dbID': 'id',
				'Tipo': 'type',
				'Nome': 'name',
				'Empresa': 'company',
				'Email': 'email',
				'Telefone': 'phone',
				'Comentário': 'comment',
				'URL': 'url',
				'Data': 'createdAt',
			},
			json_data: [
				{
					'name': 'Tony Peña',
					'city': 'New York',
					'country': 'United States',
					'birthdate': '1978-03-15',
					'phone': {
						'mobile': '1-541-754-3010',
						'landline': '(541) 754-3010'
					}
				},
				{
					'name': 'Thessaloniki',
					'city': 'Athens',
					'country': 'Greece',
					'birthdate': '1987-11-23',
					'phone': {
						'mobile': '+1 855 275 5071',
						'landline': '(2741) 2621-244'
					}
				}
			],
			json_meta: [
				[
					{
						'key': 'charset',
						'value': 'utf-8'
					}
				]
			]
		}
	},
	created: function() {
		this.get();
		this.getFilters();
	},
	methods: {
		getFilters: async function() {
			axios
				.get( this.$myServerAddresses.contact + 'contact/filters', {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                })
				.then( result => {
					this.filters = result.data.filter( elem => elem.type ).map( elem => elem.type )
				});
		},
		get: async function() {
			axios
				.get( this.$myServerAddresses.contact + 'contact', {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                })
				.then( result => {
					this.contacts = result.data.map( elem => {
						elem.showurl = elem.url
						if(elem.showurl && elem.showurl.length > 42)
							elem.showurl = elem.showurl.slice(0,42) + '...';
						var newData = elem.createdAt.slice(0,-8).split('T');
						elem.orignalCreatedAt = elem.createdAt;
						elem.createdAt = newData[0].split('-').reverse().join('/') + ' ' + newData[1];
						return elem;
					});
				});
		},
		edit: function( index ) {
			this.$router.push({ name: 'contacts-edit', params: { id: index } });
		},
		filter: function() {
			if( this.selected_filters.length )
			{
				axios
					.get( this.$myServerAddresses.contact + 'contact/filters/' + this.selected_filters.join(','), {
                        headers: {
                            'X-Fluke': this.$cookies.get('token')
                        }
                    })
					.then( result => {
						this.contacts = result.data.map( elem => {
						elem.showurl = elem.url
						if(elem.showurl && elem.showurl.length > 42)
							elem.showurl = elem.showurl.slice(0,42) + '...';
						var newData = elem.createdAt.slice(0,-8).split('T');
                        elem.orignalCreatedAt = elem.createdAt;
						elem.createdAt = newData[0].split('-').reverse().join('/') + ' ' + newData[1];
						return elem;
					});;
					})
			} else {
				this.get();
			}
		}
	}
}
</script>

